<template lang="pug">
a(
  :style="linkStyles",
  v-on:click.stop="clickHandler",
  v-if="clickHandler",
  :class="customClass"
) {{ text }}
a(
  :style="linkStyles",
  :href="url",
  :target="hrefTarget",
  rel="noopener",
  v-else
) {{ text }}
</template>

<script lang="ts">
import Vue from "vue"
import THEME from "../../constants/theme"
const { hyperlink, rootFontSize } = THEME.typography

export default Vue.extend({
  name: "Hyperlink",
  props: {
    url: { type: String, default: "#" },
    small: { type: Boolean, default: false },
    text: { type: String, default: "Mehr" },
    clickHandler: Function,
    targetBlank: { type: Boolean, default: false },
    color: { type: String, default: "primary" },
    customClass: { type: String, required: false },
  },
  computed: {
    linkStyles(): object {
      return {
        ...hyperlink,
        ...(this.small && this.smallLinkStyles),
        color: this.setColor,
      }
    },
    smallLinkStyles(): object {
      return {
        fontSize: `${0.8 * rootFontSize}px`,
        lineHeight: `${0.8 * 1.6 * rootFontSize}px`,
      }
    },
    setColor(): string | undefined {
      switch (this.color) {
        case "primary":
          return this.$vuetify.theme.themes.light.primary?.toString()
        case "textColor":
          return this.$vuetify.theme.themes.light.textColor?.toString()
        default:
          return `${this.color}`
      }
    },
    hrefTarget(): string {
      return this.targetBlank ? "_blank" : "_self"
    },
  },
})
</script>
